import * as validUrl from "valid-url";
import { GTMEvent, GTMEvents } from "@libs/utils/gtm";

export const isExternalUrl = (urlStr: string): boolean => {
  const url = validUrl.isWebUri(urlStr) && new URL(urlStr);
  if (!url) {
    return false;
  }
  if (url.hostname === "support.fansta.jp") {
    return true;
  }

  return !(
    url.hostname === "fansta.jp" ||
    url.hostname.endsWith(".fansta.jp") ||
    url.host === "localhost:4000"
  );
};

export const launchTel = (tel: string, buttonLabel: string): void => {
  window.location.href = `tel:${tel}`;
  GTMEvent(GTMEvents.telButtonPressed(buttonLabel));
};
